var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.643311 22.6074C0.643311 23.0216 0.979097 23.3574 1.39331 23.3574L8.14331 23.3574C8.55752 23.3574 8.89331 23.0216 8.89331 22.6074C8.89331 22.1932 8.55752 21.8574 8.14331 21.8574L2.14331 21.8574L2.14331 15.8574C2.14331 15.4432 1.80752 15.1074 1.39331 15.1074C0.979097 15.1074 0.64331 15.4432 0.64331 15.8574L0.643311 22.6074ZM23.3565 1.39422C23.3565 0.980005 23.0207 0.644219 22.6065 0.64422L15.8565 0.644219C15.4423 0.64422 15.1065 0.980006 15.1065 1.39422C15.1065 1.80843 15.4423 2.14422 15.8565 2.14422L21.8565 2.14422L21.8565 8.14422C21.8565 8.55843 22.1923 8.89422 22.6065 8.89422C23.0207 8.89422 23.3565 8.55843 23.3565 8.14422L23.3565 1.39422ZM1.39331 22.6074L1.92364 23.1378L23.1368 1.92455L22.6065 1.39422L22.0762 0.86389L0.86298 22.0771L1.39331 22.6074Z",
    fill: "#6C6859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.0523569a9bcc34f99bcf0cbb527415e3.svg";
export { ForwardRef as ReactComponent };